export default __webpack_public_path__ + "static/media/edit-cliente-venta.0dadbec1.svg";